/**
 * This is a function for find and return the maximum available date.
 *
 * @param {string} dayFrom - Selected start date
 * @param {string} dayTo - Selected end date
 * @param {number} availableDays - Available days from allocation
 * @return {string} - Return correctly max available date
 *
 * @example
 *
 *     getMaxDate('2020-07-10', '2020-07-30', 5)
 *     // -> '2020-07-16'
 */

import moment from 'moment'

const getMaxDate = (dayFrom, dayTo, availableDays) => {
  if (availableDays === 0) return null
  if (dayFrom) {
    const dateStart = moment(dayFrom)
    const maxDate = dateStart

    if (dateStart.isoWeekday() === 6) {
      dateStart.add(2, 'days')
    } else if (dateStart.isoWeekday() === 7) {
      dateStart.add(1, 'days')
    }

    if (availableDays === null) {
      return dayTo
    }
    for (let i = 1; i < availableDays; i++) {
      if (maxDate.isoWeekday() === 5) maxDate.add(3, 'days')
      else {
        maxDate.add(1, 'days')
      }
    }
    return maxDate.toDate()
  }
}

export default getMaxDate
